import { render, staticRenderFns } from "./vue_cropper.vue?vue&type=template&id=5dc4d667&scoped=true"
import script from "./vue_cropper.vue?vue&type=script&lang=js"
export * from "./vue_cropper.vue?vue&type=script&lang=js"
import style0 from "./vue_cropper.vue?vue&type=style&index=0&id=5dc4d667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4d667",
  null
  
)

export default component.exports